import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import {
  IRowMeta,
  timeWindowSetAction,
} from '../../../../redux/slices/oldBuilder';
import { eventTimeWindowSelector } from '../../../../redux/selectors/builder';
import BuilderEventsInput from '../../../../components/Builder/BuilderFields/BuilderEventsInput';
import { IFilterFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { BuilderNumberInputField } from '../../../../components/Builder/BuilderFields';
import {
  MAX_PREDICTION_TIME_WINDOW,
  MIN_PREDICTION_TIME_WINDOW,
} from '../../../../config/constants';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { BuilderFilterFieldsTrigger } from '../../../../components/Builder/BuilderFields/BuilderFilterFields';
import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import PredictionEventFilters from './PredictionEventFilters';
import { createDictionaryEntityDropzoneId } from '../../../../components/DndEntity/utils';
import { EntityDropzoneType } from '../../../../components/QuickAccessDictionary/DictionaryTabs/types';

interface IProps {
  rowMeta: IRowMeta;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

const Row = styled(BuilderUI.BuilderFieldContainer)`
  column-gap: 8px;
`;

const Label = styled(BuilderUI.BuilderFieldLabel)`
  margin-right: 0;
`;

const StyledNumberInput = styled(BuilderNumberInputField)`
  width: 120px;
`;

export default memo(({ rowMeta }: IProps) => {
  const dispatch = useAppDispatch();
  const filter: IFilterFieldsFragment = useAppSelector(
    ({ builder }) => builder.prediction.eventCondition?.filter,
  );
  const fieldsDropzoneId = createDictionaryEntityDropzoneId(
    EntityDropzoneType.Fields,
    rowMeta,
  );

  const hasConditions = filter && filter?.conditions?.length > 0;
  const memoEventTimeWindowSelector = useMemo(eventTimeWindowSelector, []);
  const eventTimeWindowValue = useAppSelector((state) =>
    memoEventTimeWindowSelector(state, { ...rowMeta, numberIndex: 0 }),
  );
  const handleTimeWindowValueChange = (newValue: number | null) => {
    dispatch(
      timeWindowSetAction({
        newValue: newValue?.toString() ?? '',
        rowMeta: { ...rowMeta, numberIndex: 0 },
      }),
    );
  };

  return (
    <>
      <Container>
        <Row>
          <Label>Action Event(s)</Label>
          <BuilderEventsInput rowMeta={rowMeta} />
        </Row>
        <Row>
          <Label>done within</Label>
          <StyledNumberInput
            placeholder="1~14"
            value={eventTimeWindowValue}
            onChange={handleTimeWindowValueChange}
            min={MIN_PREDICTION_TIME_WINDOW}
            max={MAX_PREDICTION_TIME_WINDOW}
            rowMeta={{ ...rowMeta, numberIndex: 0 }}
            errorKey="timeWindow"
          />
          <Label>days</Label>
        </Row>
        <BuilderFilterFieldsTrigger
          rowMeta={rowMeta}
          fieldsDropzoneId={fieldsDropzoneId}
        />
      </Container>
      {hasConditions && (
        <PredictionEventFilters rowMeta={rowMeta} filter={filter} />
      )}
    </>
  );
});
